import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { GridsterModule } from 'angular-gridster2';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { Overlay } from '@angular/cdk/overlay';
import {
  MatLegacyAutocompleteModule as MatAutocompleteModule,
  MAT_LEGACY_AUTOCOMPLETE_SCROLL_STRATEGY as MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
} from '@angular/material/legacy-autocomplete';
import { SharedModule } from 'app/shared/shared.module';
import { customObjectsRoutes } from './custom-objects.routing';
import { CustomObjectsComponent } from './custom-objects.component';
import { CustomObjectsListComponent } from './list/list.component';
import { HasPermissionPipe } from '@shared/pipes/has-permission.pipe';
import { CustomObjectsQuickViewComponent } from './quick-view/quick-view.component';
import { PanelsModule } from 'app/shared/components/panels/panels.module';
import {
  CustomObjectsDashboardComponent,
  CustomObjectsDashboardHeaderComponent,
  CustomObjectsDetailsTabNavComponent,
  CustomObjectsDashboardDetailsComponent,
} from './dashboard';
import { TreoNavigationModule } from 'tsui/@treo';
import { CustomObjectsSidebarComponent } from './custom-objects-sidebar/custom-objects-sidebar.component';
import { SavedViewSidebarComponent } from 'app/shared/components/saved-view-sidebar/saved-view-sidebar.component';
import { FieldSelectorComponent } from 'app/modules/reporting/@components/builder/field-selector/field-selector.component';
import { ColumnSelectorModule } from 'app/shared/components/column-selector/column-selector.module';
import {
  TsPageHeaderModule,
  TsPaginatorModule,
  TsBreadcrumbModule,
  TsButtonModule,
  TSIconModule,
  TsBadgeModule,
  TsOverlayModule,
  TsFilterModule,
  TsPageComponent,
  TsInputComponent,
  TsPipesModule,
  TsMenuComponent,
} from 'tsui';
import { TsTableComponent } from 'tsui/lib/ts-table';
import { TsDialogComponent } from 'tsui/lib/ts-dialog/ts-dialog.component';

const TSUI_MODULES = [
  TsPipesModule,
  TsPageHeaderModule,
  TsPageComponent,
  TsPaginatorModule,
  TsBreadcrumbModule,
  TsButtonModule,
  TSIconModule,
  TsBadgeModule,
  TsOverlayModule,
  TsFilterModule,
  TsDialogComponent,
  TsInputComponent,
  TsTableComponent,
  TsMenuComponent,
];

@NgModule({
  declarations: [
    CustomObjectsComponent,
    CustomObjectsListComponent,
    CustomObjectsQuickViewComponent,
    CustomObjectsDashboardComponent,
    CustomObjectsDetailsTabNavComponent,
    CustomObjectsDashboardDetailsComponent,
    CustomObjectsSidebarComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(customObjectsRoutes),
    ReactiveFormsModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatSortModule,
    MatSelectModule,
    MatProgressBarModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    SharedModule,
    DragDropModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSidenavModule,
    MatAutocompleteModule,
    MatTabsModule,
    GridsterModule,
    MatMenuModule,
    MatDividerModule,
    PanelsModule,
    MatProgressBarModule,
    TreoNavigationModule,
    ColumnSelectorModule,
    SavedViewSidebarComponent,
    FieldSelectorComponent,
    ...TSUI_MODULES,
    CustomObjectsDashboardHeaderComponent,
    HasPermissionPipe,
  ],
  providers: [
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => {
        return () => overlay.scrollStrategies.block();
      },
      deps: [Overlay],
    },
  ],
})
export class CustomObjectsModule {}
